import { MAPS_MODE } from '../constants/maps';

export const invertMapsMode = (value) => (value === MAPS_MODE.MAP
  ? MAPS_MODE.SATELLITE
  : MAPS_MODE.MAP);
